import { Person } from './person';
import { Observable } from 'rxjs';

export enum MaritalStatus {
  Single = 'Single',
  Married = 'Married',
  Widowed = 'Widowed',
  Divorced = 'Divorced',
}

export namespace MaritalStatus {
  export function values() {
    return Object.keys(MaritalStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values',
    );
  }
}

export enum OfficialLanguages {
  Afrikaans = 'Afrikaans',
  English = 'English',
  Zulu = 'Zulu',
  Xhosa = 'Xhosa',
  Venda = 'Venda',
  SouthernSotho = 'Southern Sotho',
  Tswana = 'Tswana',
  Tsonga = 'Tsonga',
  NorthernSotho = 'Northern Sotho',
  Swati = 'Swati',
  Ndebele = 'Ndebele',
}

export namespace OfficialLanguages {
  export function values() {
    return Object.keys(OfficialLanguages).filter(
      (type) => isNaN(<any>type) && type !== 'values',
    );
  }
}

export enum Title {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Miss = 'Miss',
  Dr = 'Dr',
}

export namespace Title {
  export function values() {
    return Object.keys(Title).filter(
      (type) => isNaN(<any>type) && type !== 'values',
    );
  }
}

export interface Patient extends Person {
  personResponsibleForAccount?: Person;
  wcaClientNo?: string;
}

export abstract class PatientData {
  abstract getAllPatients(): Observable<Patient[]>;
  abstract getOnePatient(patientId: string): Observable<Patient>;
  abstract createPatient(patient: Patient): void;
  abstract deletePatient(patientId: string): void;
  abstract updatePatient(patient: Patient): void;
}
